import { useGetCurrentOrganization } from '@/api/trafikportalen';
import { useListAllpayUsers } from '@/api/trafikportalen/trafikportalenAPI';
import { useListCardCredits } from '@/api/trafikportalen/trafikportalenAPI';
import { useGetSpentCredit } from '@/api/trafikportalen/trafikportalenAPI';

export const useOrgCreditInfo = (): {
  allpayCredit: number;
  cardCredit: number;
  portalSpent: number;
  totalSpent: number;
  remainingCredit: number;
  isLoading: boolean;
  hasNoCreditLimit: boolean;
} => {
  const { data: organization, isLoading: orgIsLoading } =
    useGetCurrentOrganization();
  const { data: allpayUsers, isLoading: allpayIsLoading } =
    useListAllpayUsers();
  const { data: cardCredits, isLoading: cardCreditsIsLoading } =
    useListCardCredits();
  const { data: spent = 0, isLoading: spentIsLoading } = useGetSpentCredit();

  if (orgIsLoading || allpayIsLoading || cardCreditsIsLoading || spentIsLoading)
    return {
      allpayCredit: 0,
      cardCredit: 0,
      portalSpent: 0,
      totalSpent: 0,
      remainingCredit: 0,
      isLoading: true,
      hasNoCreditLimit: false,
    };

  const allpayCredit =
    allpayUsers?.reduce((acc, user) => {
      return acc + user.credit;
    }, 0) ?? 0;

  const cardCredit =
    cardCredits?.reduce((acc, card) => {
      return acc + card.credit;
    }, 0) ?? 0;

  const travellerCredit = allpayCredit + cardCredit;

  const portalSpent = spent - travellerCredit;

  const totalSpent = portalSpent + travellerCredit;

  const remainingCredit = Math.max((organization?.credit ?? 0) - totalSpent, 0);

  return {
    allpayCredit,
    cardCredit,
    portalSpent,
    totalSpent,
    remainingCredit,
    isLoading: false,
    hasNoCreditLimit:
      organization && organization.credit === undefined ? true : false,
  };
};
